import "@/businessLogicRegistry";
import { ConfigWrapper } from "@/components/ConfigWrapper";
import { ThemeProvider } from "@/context/ThemeContext";
import "@/i18n";
import "@/instrument";
import { registerPwa } from "@/pwa/registerPwa";
import "@/styles/index.css";
import { setupDevtoolsProtection } from "@/utils/devtoolsProtection";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

setupDevtoolsProtection();
registerPwa();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ThemeProvider>
      <ConfigWrapper />
    </ThemeProvider>
  </StrictMode>
);
